<div class="container-fluid p-3">
  <div class="bg-white rounded-md  border-2 border-blue-900 border-gray-300 px-4 py-2 sm:p-6 mb-4">
    <div class="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
    <div class="flex gap-3">
    
      <div class="flex-1">
        <h4 class="text-xl sm:text-2xl font-bold text-slate-800 mb-1">
          {{stepDetails?.name}}
        </h4>
    
        <h5 class="text-base sm:text-lg text-blue-600 font-semibold mb-3">
          [{{ proposalName }}]
        </h5>
    
    
      </div>
      <div>
        
        <span class="inline-flex items-center px-3 py-1.5 border-2 rounded-full text-sm font-bold transition-all" [ngClass]="{
                        'bg-slate-100 text-slate-700 border border-slate-500': stepDetails?.step_status == 0,
                        'bg-emerald-100 text-emerald-700 border border-emerald-500': stepDetails?.step_status == 'approved',
                        'bg-amber-100 text-amber-700 border border-amber-500': stepDetails?.step_status == 'recommended',
                        'bg-blue-100 text-blue-700 border border-blue-500': stepDetails?.step_status == 'initiated'
                      }">
          <span class="w-2 h-2 rounded-full mr-2 animate-pulse" [ngClass]="{
                          'bg-slate-500': stepDetails?.step_status == 0,
                          'bg-emerald-500': stepDetails?.step_status == 'approved',
                          'bg-amber-500': stepDetails?.step_status == 'recommended',
                          'bg-blue-500': stepDetails?.step_status == 'initiated'
                        }"></span>
          {{ stepDetails?.step_status == 0 ? " PENDING" : (stepDetails?.step_status | uppercase) }}
        </span>
      </div>
    </div>

      <!-- Action Buttons -->
      <div class="flex flex-wrap items-center gap-2">
        <!-- <button (click)="getPdf()" 
                class="inline-flex items-center px-4 py-2.5 bg-white border-2 border-slate-300 text-slate-700 rounded-lg hover:bg-slate-50 hover:border-slate-400 transition-all duration-200 font-medium text-sm shadow-sm hover:shadow">
          <i class="pi pi-file-pdf mr-2"></i> PDF
        </button> -->

       

        <ng-container *ngIf="stepDetails?.can_edit">
          <button (click)="routeConfig.emit({isRouteConfig: true})"  class="inline-flex items-center px-4 py-2.5 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 disabled:bg-slate-300 disabled:cursor-not-allowed transition-all duration-200 font-medium text-sm shadow-sm hover:shadow-md">
            <i class="pi pi-save mr-2"></i> Save/Forward/Route Config
          </button>
        </ng-container>
      </div>
    </div>
  </div>

  <hr class="my-3" />

  <!-- Production Dates Section -->
  <div *ngIf="urls.TGPUrl" class="mt-3 mb-4">
    <div *ngIf="stepDetails?.can_edit" class="d-flex justify-content-end mb-2">
      <button class="add-btn bg-primary text-white py-2 px-3" (click)="addProductionDateRow()">+ Add Row</button>
    </div>
    <table class="custom-table table mb-4">
      <thead>
        <tr>
          <th class="bg-primary text-white py-2">FATs Date</th>
          <th class="bg-primary text-white py-2">Bulk Delivery Date</th>
          <th class="bg-primary text-white py-2">HATs Date</th>
          <th class="bg-primary text-white py-2">SATs Date</th>
          <th *ngIf="schemeType == 'rev'"  class="bg-primary text-white py-2">Delivered On</th>
          <th *ngIf="schemeType == 'rev'"  class="bg-primary text-white py-2">System</th>
          <th *ngIf="schemeType == 'rev'" class="bg-primary text-white py-2">Dispatch Clearance Date</th>
          
          <th *ngIf="stepDetails?.can_edit" class="bg-primary text-white py-2">Action</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let row of productionDates; let i = index">
          <td>
            <ng-container *ngIf="row.edit; else fatDisplay">
              <input type="date" class="form-control" [(ngModel)]="row.fat_date" />
            </ng-container>
            <ng-template #fatDisplay>{{ row.fat_date }}</ng-template>
          </td>
          <td>
            <ng-container *ngIf="row.edit; else bulkDisplay">
              <input type="date" class="form-control" [(ngModel)]="row.bulk_delivery_date" />
            </ng-container>
            <ng-template #bulkDisplay>{{ row.bulk_delivery_date }}</ng-template>
          </td>
          <td>
            <ng-container *ngIf="row.edit; else hatDisplay">
              <input type="date" class="form-control" [(ngModel)]="row.hat_date" />
            </ng-container>
            <ng-template #hatDisplay>{{ row.hat_date }}</ng-template>
          </td>
          <td>
            <ng-container *ngIf="row.edit; else satDisplay">
              <input type="date" class="form-control" [(ngModel)]="row.sat_date" />
            </ng-container>
            <ng-template #satDisplay>{{ row.sat_date }}</ng-template>
          </td>
           <td *ngIf="schemeType == 'rev'">
            <ng-container *ngIf="row.edit; else deliveredOn">
              <input type="date" class="form-control" [(ngModel)]="row.delivered_on" />
            </ng-container>
            <ng-template #deliveredOn>{{ row.delivered_on }}</ng-template>
          </td>
          <td *ngIf="schemeType == 'rev'">
            <ng-container *ngIf="row.edit; else system">
              <input type="text" class="form-control" [(ngModel)]="row.system" />
            </ng-container>
            <ng-template #system>{{ row.system }}</ng-template>
          </td>
           <td *ngIf="schemeType == 'rev'">
            <ng-container *ngIf="row.edit; else clearanceDisplay">
              <input type="date" class="form-control" [(ngModel)]="row.clearance_date" />
            </ng-container>
            <ng-template #clearanceDisplay>{{ row.clearance_date }}</ng-template>
          </td>
          <td>
            <ng-container *ngIf="stepDetails?.can_edit">
              <button class="btn btn-sm btn-outline-primary me-1" *ngIf="!row.edit" (click)="row.edit = true">Edit</button>
              <button class="btn btn-sm btn-success" *ngIf="row.edit" (click)="saveProductionDateRow(row)">Save</button>
            </ng-container>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <form [formGroup]="commentForm">
    
    <div *ngIf="urls.GPUrl" class="mb-4 editor-container">
      <label class="bg-primary text-white p-2"> Comment </label>
      <editor [init]="init" formControlName="final_offer" ></editor>
    </div>
    <div *ngIf="schemeType == 'rev' || schemeType == 'makeI'" class="p-6 space-y-4 border-t border-slate-100 animate-fade-in">
            
            <div class="mb-4">
              <label for="bpc_issue_date" class="block bg-blue-500 text-white font-medium p-2 mb-1 rounded">
                <strong>Clearance from Professional Dte for BPC Date</strong>
              </label>
              <input type="date" id="bpc_issue_date"
                class="form-control border-2 border-blue-200 rounded px-2 py-1 w-full max-w-sm"
                formControlName="bpc_issue_date">
            </div>
          
         
          </div>
  </form>
  <div class="row mb-4">
   
    <app-upload-document [title]="'Bulk Production Clearance (BPC) Certificate'" [isEditable]="stepDetails?.can_edit"> </app-upload-document>
    
  </div>
</div>